import React, { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Loginimg from '../images/login.png'
import Logo from '../images/logo.png'
import Form from 'react-bootstrap/Form';
import { useNavigate,Link,Navigate } from 'react-router-dom';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import supabase from "../supabase"

function Login() {
    const [userData,setUserData] = useState({username:'',password:''})
    const [loading, setLoading] = useState(false);
    const [valError,setValError] = useState({username:'',password:''})
    const [serverError,setServerError] = useState("")
    const [token,setToken] = useState(localStorage.getItem("AccessToken")||null)

    const navigate = useNavigate();

    const [passwordToggle, setPasswordToggle] = useState(true);

    const passwordVisible = () =>{
        setPasswordToggle(!passwordToggle)
    }      

    const onSubmit = async () =>{
        const {username,password} = userData
        const regEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let validate = true;
        if(username==''){
            setValError((prev) => ({
                ...prev,
                username: "Username must be required",
            }));
            validate = false
        }else if(!regEx.test(username)){
            setValError((prev) => ({
                ...prev,
                username: "Username is not valid",
            }));
            validate = false
        }
        if(password==''){
            setValError((prev) => ({
                ...prev,
                password: "Password must be required",
            }));
            validate = false
        }
        if(validate){
            setLoading(true)
            let { data, error } = await supabase.auth.signInWithPassword({
                email: userData.username,
                password: userData.password
            })
            if(data.user==null || data.session==null){
                setServerError("Invalid login credentials")
                setLoading(false)
            }else{
                if(data?.session?.access_token){
                    localStorage.setItem("AccessToken",data.session.access_token)
                }
                navigate("/admin-dashboard");
                setLoading(false)
            }
        }
    }

    const onChange = (e) =>{
        const { name, value } = e.target;
        setUserData((prev) => ({
        ...prev,
        [name]: value,
        }));
        setValError((prev)=>({
            ...prev,
            [name]: "",
        }))
    }

    return (
        <>
        {token ? <Navigate to='/admin-dashboard'/> : 
        <Container fluid>
            <Row>
                <div className='login-wrapper'>
                    <div className="login-content">
                        <div className="login-userset">
                            <div className="login-logo">
                                <img src={Logo} alt="login" className='w-100'/>
                            </div>
                            <div className="login-userheading">
                                <h3>Log In</h3>
                            </div>
                            <Form>
                                <div className="form-login">
                                    <Form.Label>Username</Form.Label>
                                    <div className="pass-group">
                                        <Form.Control type="email" onChange={(e)=>onChange(e)} value={userData.username} placeholder="Enter your Username/Email" name="username" required/>
                                        <span className="fas toggle-user fa-user"></span>
                                    </div>
                                    {valError.username && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{valError.username}</small>}
                                </div>
                                <div className="form-login mt-3">
                                    <Form.Label>Password</Form.Label>
                                    <div className="pass-group">
                                        <Form.Control value={userData.password} onChange={(e)=>onChange(e)} type={`${passwordToggle ? 'password' : 'text'}`} className="pass-input" placeholder="Enter your Username/Email" name="password" required/>
                                        <span className={`fas toggle-password fa-${passwordToggle ? 'eye' : 'eye-slash'}`} onClick={passwordVisible}></span>
                                    </div>
                                    {valError.password && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{valError.password}</small>}
                                </div>
                                {serverError && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{serverError}</small>}
                                <div className="form-login">
                                    <input type='button' name="submit" onClick={onSubmit} className="btn btn-login" value="Log In" />
                                </div>
                            </Form>
                        </div>
                    </div>
                    <div className="login-img">
                        <img src={Loginimg} alt="login-right"/>
                    </div>
                </div>
            </Row>
        </Container>}
        </>
    )
}

export default Login